export default __webpack_public_path__ + "static/media/AFTIM-FACTURACION-POS.2f7aec87.pdf";